module.exports = [
    {
        path: '/',
        component: () => import(/* webpackChunkName: "home" */ '@/views/HomeLayout.vue'),
        children: [
          {
            path: '/',
            alias: 'home',
            component: () => import(/* webpackChunkName: "home" */ '@/views/website/StartPage')
          },
          {
            path: 'uebermich',
            alias: '/uebermich',
            component: () => import(/* webpackChunkName: "second" */ '@/views/website/UebermichPage')
          },
          {
            path: 'immobilienmarketing',
            alias: '/immobilienmarketing',
            component: () => import(/* webpackChunkName: "second" */ '@/views/website/ImmobilienmarketingPage')
          },
          {
            path: 'referenzen',
            alias: '/referenzen',
            component: () => import(/* webpackChunkName: "second" */ '@/views/website/ReferenzenPage')
          },
          {
            path: 'angebot',
            alias: '/angebot',
            component: () => import(/* webpackChunkName: "second" */ '@/views/website/AngebotsPage')
          },
          {
            path: 'mediathek',
            alias: '/mediathek',
            component: () => import(/* webpackChunkName: "second" */ '@/views/website/MediathekPage')
          },
          {
            path: 'kontakt',
            alias: '/kontakt',
            component: () => import(/* webpackChunkName: "second" */ '@/views/website/KontaktPage')
          },
          {
            path: 'impressum',
            alias: '/impressum',
            component: () => import(/* webpackChunkName: "others" */ '@/views/website/ImpressumPage')
          },
          {
            path: 'datenschutz',
            alias: '/datenschutz',
            component: () => import(/* webpackChunkName: "others" */ '@/views/website/DatenschutzPage')
          }
        ]
      }
]
